
    import * as React from 'react';

    const Sort20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" fill="none" style={svgStyle}><path d="M5 1 L10 6 L9 7 L5.7 3.7 L5.7 18.4 L4.3 18.4 L4.3 3.7 L1 7 L0 6 L5 1" /><path d="M15 19 L20 14 L19 13 L15.7 16.3 L15.7 1.6 L14.3 1.6 L14.3 16.3 L11 13 L10 14 L15 19" /></svg>
        </div>
      );
    };

    Sort20.displayName = 'Sort20';

    export default Sort20;
  